export default __webpack_public_path__ + "static/media/Mark-2-HUD-Pop-Up (Process) 4in1.ead1ee0d.jpg";